import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import SectionTitleComponent from "./SectionTitle";
import SingleCategoryViewCel from "./CategoryCelView";
const CategoryViewCel = ({ list }) => {
  console.log("list in category view", list);
  const navigate = useNavigate();
  return (
    <div className="container">
      {/* <div>
        <SectionTitleComponent />
      </div> */}
      <div className="row d-flex align-items-center">
        {list.length === 2 ? (
          list.map((item, index) => (
            <div key={index} onClick={() => navigate(`/hi-value-plus/products?id=${item.id}`)} className="col-12 col-lg-6  mt-2 mb-2 h-100">
              {
                <SingleCategoryViewCel
                  data={item}
                  buttonPosition="bottom-left"
                  customHeight="full"
                />
              }
            </div>
          ))
        ) : list.length === 3 ? (
          list.map((item, index) => (
            <div key={index} onClick={() => navigate(`/hi-value-plus/products?id=${item.id}`)} className="col-12 col-lg-4  mt-2 mb-2 h-100">
              {
                <SingleCategoryViewCel
                  data={item}
                  buttonPosition="bottom-left"
                  customHeight="full"
                />
              }
            </div>
          ))
        ) : list.length > 3 ? (
          <>
            {/* Left big item */}
            <div  onClick={() => navigate(`/hi-value-plus/products?id=${list[0].id}`)} className="col-12 col-lg-4 mt-2 mb-2 d-flex" style={{ height: "402px" }}>
              <SingleCategoryViewCel
                data={list[0]}
                buttonPosition="bottom-left"
                customHeight="full"
              />
            </div>

            {/* Middle stacked (two half height items) */}
            <div className="col-12 col-lg-4 mt-2 mb-2" style={{ height: "402px" }}>
              <div className="row h-100">
                <div onClick={() => navigate(`/hi-value-plus/products?id=${list[1].id}`)} className="col-12 mb-2 d-flex" style={{ height: "48%" }}>
                  <SingleCategoryViewCel
                    data={list[1]}
                    buttonPosition="top-left"
                    customHeight="half"
                  />
                </div>
                <div onClick={() => navigate(`/hi-value-plus/products?id=${list[2].id}`)} className="col-12 d-flex" style={{ height: "48%" }}>
                  <SingleCategoryViewCel
                    data={list[2]}
                    buttonPosition="bottom-left"
                    customHeight="half"
                  />
                </div>
              </div>
            </div>

            {/* Right big item */}
            <div  onClick={() => navigate(`/hi-value-plus/products?id=${list[3].id}`)} className="col-12 col-lg-4 mt-2 mb-2 d-flex" style={{ height: "402px" }}>
              <SingleCategoryViewCel
                data={list[3]}
                buttonPosition="bottom-right"
                customHeight="full"
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(CategoryViewCel);
